/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAdminUserWalletDetailPageListRespVo
 */
export interface GetAdminUserWalletDetailPageListRespVo {
    /**
     * No.
     * @type {number}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    id?: number;
    /**
     * 用户 ID，关联用户表主键
     * @type {number}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    userId?: number;
    /**
     * 会员编号
     * @type {string}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    userCode?: string;
    /**
     * 会员名称
     * @type {string}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    userName?: string;
    /**
     * 钱包类型：1-韩国钱包，2-中国账单钱包
     * @type {number}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    walletType?: number;
    /**
     * 使用区分编号
     * @type {number}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    usedId?: number;
    /**
     * 使用区分类型：1-预存款充值，2-预存款调整，3-预存款退款，4-账单费用，5-管理员充值/扣费
     * @type {number}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    usedType?: number;
    /**
     * 使用区分描述
     * @type {string}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    usedTypeDesc?: string;
    /**
     * 内容
     * @type {string}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    remark?: string;
    /**
     * 预存款-出入金额
     * @type {number}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    amount?: number;
    /**
     * 预存款余额-出入金之后的钱包余额
     * @type {number}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    principal?: number;
    /**
     * 出金入金类型：0-出金，1-入金
     * @type {number}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    intOutType?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof GetAdminUserWalletDetailPageListRespVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the GetAdminUserWalletDetailPageListRespVo interface.
 */
export function instanceOfGetAdminUserWalletDetailPageListRespVo(value: object): value is GetAdminUserWalletDetailPageListRespVo {
    return true;
}

export function GetAdminUserWalletDetailPageListRespVoFromJSON(json: any): GetAdminUserWalletDetailPageListRespVo {
    return GetAdminUserWalletDetailPageListRespVoFromJSONTyped(json, false);
}

export function GetAdminUserWalletDetailPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminUserWalletDetailPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'walletType': json['walletType'] == null ? undefined : json['walletType'],
        'usedId': json['usedId'] == null ? undefined : json['usedId'],
        'usedType': json['usedType'] == null ? undefined : json['usedType'],
        'usedTypeDesc': json['usedTypeDesc'] == null ? undefined : json['usedTypeDesc'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'principal': json['principal'] == null ? undefined : json['principal'],
        'intOutType': json['intOutType'] == null ? undefined : json['intOutType'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function GetAdminUserWalletDetailPageListRespVoToJSON(json: any): GetAdminUserWalletDetailPageListRespVo {
    return GetAdminUserWalletDetailPageListRespVoToJSONTyped(json, false);
}

export function GetAdminUserWalletDetailPageListRespVoToJSONTyped(value?: GetAdminUserWalletDetailPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'walletType': value['walletType'],
        'usedId': value['usedId'],
        'usedType': value['usedType'],
        'usedTypeDesc': value['usedTypeDesc'],
        'remark': value['remark'],
        'amount': value['amount'],
        'principal': value['principal'],
        'intOutType': value['intOutType'],
        'createTime': value['createTime'],
    };
}

